"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRangeslider = _interopRequireDefault(require("react-rangeslider"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Range = /*#__PURE__*/function (_Component) {
  function Range(props, context) {
    var _this;
    (0, _classCallCheck2["default"])(this, Range);
    _this = _callSuper(this, Range, [props, context]);
    // Keeping start / completed incase we want to do some magic later...
    (0, _defineProperty2["default"])(_this, "handleChangeStart", function () {
      // console.log('Change event started');
    });
    (0, _defineProperty2["default"])(_this, "handleChange", function (value) {
      _this.setState({
        value: value
      });
    });
    (0, _defineProperty2["default"])(_this, "handleChangeComplete", function () {
      // console.log('Change event completed');
    });
    _this.state = {
      value: 1
    };
    return _this;
  }
  (0, _inherits2["default"])(Range, _Component);
  return (0, _createClass2["default"])(Range, [{
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props = this.props,
        label = _this$props.label,
        min = _this$props.min,
        max = _this$props.max,
        step = _this$props.step,
        alert = _this$props.alert;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-c-range margin-bottom-sm"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-l-half-grid"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm",
        htmlFor: label.replace(/\s+/g, '-').toLowerCase(),
        "data-section": "form-label"
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-right"
      }, value)), /*#__PURE__*/_react["default"].createElement(_reactRangeslider["default"], {
        min: min,
        max: max,
        step: step,
        value: value,
        tooltip: false,
        onChangeStart: this.handleChangeStart,
        onChange: this.handleChange,
        onChangeComplete: this.handleChangeComplete
      }), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        className: "margin-top-sm",
        show: alert.showNotification,
        text: alert.notificationMessage,
        type: alert.notificationType,
        onClose: alert.onClose
      }));
    }
  }]);
}(_react.Component);
Range.propTypes = {
  label: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  step: _propTypes["default"].number,
  alert: _propTypes["default"].object
};
Range.defaultProps = {
  step: 1,
  alert: null
};
var _default = exports["default"] = Range;